import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import ContentHeader from "./ContentHeader";
import ContentTable from "./ContentTable";

const ContentList = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <ContentHeader />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <ContentTable />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default ContentList;
